var map = {
	"./labmemtest_btn_download_en.png": "b056",
	"./labmemtest_btn_download_jp.png": "94cd",
	"./labmemtest_btn_download_kr.png": "fce8",
	"./labmemtest_btn_download_sc.png": "62ae",
	"./labmemtest_btn_download_tc.png": "5c57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cd98";